<template>
  <div class="time">
    {{ time | formatDate() }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      timer: null,
      time: Date.now()
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.time = Date.now()
    }, 1000)
  }
}
</script>

<style lang="css" scoped>
.time {
  font-size: 1rem;
}
</style>
